import {
  PromotionCodeEnum,
  PromotionCodeResponseErrorCodesEnum,
} from 'app/shared/enums';
import { mainPhoneNumber } from 'app/services/env.service';

export const getPromotionErrorMessage = (errorKey?: string): string => {
  switch (errorKey) {
    case PromotionCodeResponseErrorCodesEnum.AlreadyUsed:
      return `${PromotionCodeEnum.BonusInfoContent1} ${PromotionCodeEnum.BonusInfoContent2} ${PromotionCodeEnum.BonusInfoContent3}`;

    case PromotionCodeResponseErrorCodesEnum.NotApplicableEmployeeBonus:
      return `${PromotionCodeEnum.BonusInfoContent1} ${PromotionCodeEnum.BonusInfoContent2} ${PromotionCodeEnum.BonusInfoContent9}`;

    case PromotionCodeResponseErrorCodesEnum.Referrer:
      return `${PromotionCodeEnum.CanNotUseOwnVoucher1} ${PromotionCodeEnum.CanNotUseOwnVoucher2} ${PromotionCodeEnum.CanNotUseOwnVoucher3} ${PromotionCodeEnum.CanNotUseOwnVoucher4}`;

    case PromotionCodeResponseErrorCodesEnum.PromotionForAcOnly:
      return `${PromotionCodeEnum.VoucherForAcOnly1} ${PromotionCodeEnum.VoucherForAcOnly2}`;

    case PromotionCodeResponseErrorCodesEnum.PromotionForRenewalOnly:
      return `${PromotionCodeEnum.VoucherForRenewalOnly1} ${PromotionCodeEnum.VoucherForRenewalOnly2}`;

    case PromotionCodeResponseErrorCodesEnum.OfferPriceTooLow:
      return `${PromotionCodeEnum.VoucherOfferPriceTooLow1} ${PromotionCodeEnum.VoucherOfferPriceTooLow2}`;
    case PromotionCodeResponseErrorCodesEnum.AlreadyUsedForVehicle:
      return PromotionCodeEnum.AlreadyUsedForCar;

    default:
      return mainPhoneNumber
        ? `${PromotionCodeEnum.VoucherGeneralError} ${mainPhoneNumber}`
        : '';
  }
};
